module.exports = __webpack_public_path__ + "img/red_037.a0e7857b.png";